module.exports = __webpack_public_path__ + "static/media/orden de venta preliminar.5af1fa1c.ico";